import * as React from 'react';
import { TruckIcon } from 'lucide-react';
import type {
  InvoiceIndicators,
  IndicatorStatusCode,
} from 'contracts/tracking-v2/invoice-indicators';

import { IndicatorCard as Card } from './indicator-card-toolkit';
import { getPercentage } from './utils';

type Props = {
  indicator?: InvoiceIndicators['inTransit']
  onToggleStatus: (status: IndicatorStatusCode) => void;
  activeStatus?: string | IndicatorStatusCode;
  loading?: boolean;
}

export const InTransitCard = ({
                                indicator,
                                onToggleStatus,
                                activeStatus,
                                loading,
                              }: Props) => {
  return (
    <Card.Root loading={loading}>
      <Card.Header
        title={'Em trânsito'}
        icon={<TruckIcon className={'stroke-slate-800'} />}
      />
      <Card.Body>
        <Card.BodyHeadLine
          count={indicator?.count}
          percentage={indicator?.percentage}
        />
        <Card.BodyBottomLine>
          <Card.ActionButton
            onClick={() => onToggleStatus('inTransitWithinDeadline')}
            active={activeStatus === 'inTransitWithinDeadline'}
            tooltip={indicator?.withinDeadline.count}
          >
            {getPercentage(indicator?.withinDeadline.percentage)}% no prazo
          </Card.ActionButton>
          <Card.ActionButton
            onClick={() => onToggleStatus('inTransitOverDeadline')}
            active={activeStatus === 'inTransitOverDeadline'}
            tooltip={indicator?.overDeadline.count}
          >
            {getPercentage(indicator?.overDeadline.percentage)}% com atraso
          </Card.ActionButton>
          <Card.ActionButton
            onClick={() => onToggleStatus('inTransitWithoutDeadline')}
            active={activeStatus === 'inTransitWithoutDeadline'}
            tooltip={indicator?.withoutDeadline.count}
          >
            {getPercentage(indicator?.withoutDeadline.percentage)}% sem prazo
          </Card.ActionButton>
        </Card.BodyBottomLine>
      </Card.Body>
    </Card.Root>
  );
};